<template>
  <div class="toggle d-flex">
    <div
      v-for="option in options"
      :key="option.value"
      class="toggle-item"
      :class="{
        active: toggleValue === option.value,
        disabled: option.disabled
      }"
      @click="handleSelect(option)"
    >
      {{ option.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonToggle",
  props: {
    options: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: "" }
  },
  emits: ["update:modelValue"],
  computed: {
    toggleValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    handleSelect(option) {
      if (option.disabled) return;
      this.toggleValue = option.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-item {
  flex: 1;
  border-radius: 0;
  border-color: #cdd4da;
  background-color: #fff;
  cursor: pointer;
  padding: 0 20px;
  height: 40px;
  display: flex;
  white-space: nowrap;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  font-weight: bold;
  border: 1px solid #cdd4da;
  border-right: none;
  box-shadow: var(--box-shadow);
  &:hover,
  &:active {
    background-color: #fff;
    border-color: #cdd4da;
  }
  &.active {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: white;
  }
  &.disabled {
    background-color: var(--sera-color-neutral-gray-light-gray-300);
    border-color: var(--sera-color-neutral-gray-light-gray-300);
    color: var(--sera-color-font-body);
  }
  &:first-of-type {
    border-radius: 4px 0 0 4px;
  }
  &:last-of-type {
    border-radius: 0 4px 4px 0;
    border-right: 1px solid #cdd4da;
  }
}
</style>
